import { Component, inject } from '@angular/core';
import { SIDE_DIALOG_DATA } from '../../../ecaps-core/side-dialog/side-dialog.injectors';
import { ISizeChartData } from './models/i-size-chart-data.interface';

@Component({
  selector: 'app-size-chart-dialog',
  templateUrl: './size-chart-dialog.component.html',
  styleUrls: ['./size-chart-dialog.component.scss'],
  standalone: false,
})
export class SizeChartDialogComponent {
  protected dialogData: ISizeChartData = inject(SIDE_DIALOG_DATA);
}
